
import firebase from 'firebase';
import {
    getCurrentPressPallets,
    createNew,
    save
} from "../../stores/PressPalletBuilderStore";
import PeopleStore from "../../stores/PeopleStore";
import StationAdoptStore from "../../stationadopt/StationAdoptStore";
import CheckInStore from "../../stores/CheckInStore2";
import StationsStore from "../../stores/StationsStore";
import {getJobsBetween} from "../../stores/PressJobsStore";
import {firebaseConfig} from "../../FIREBASE_CONFIG";
import {saveAs} from 'file-saver';
import _ from 'lodash';

export const onStartPallet = async (values)=> {

    console.log('Starting a pallet', {values});

    const adoptInfo = await new StationAdoptStore().read();
    var checkInInfo = await new CheckInStore().read();


    // If different person is loading than is checked in
    // Go ahead and check them in
    const checkedInId = checkInInfo ? checkInInfo.data.personId : null;
    if (values.loadOperatorId != checkedInId) {
        await new CheckInStore().save(values.loadOperatorId);
        checkInInfo = await new CheckInStore().read();
    }

    const stationId = adoptInfo.data.stationId;
    const stationInfo = await new StationsStore().findById(stationId);
    const loadTime = new Date();

    const data = {palletId: values.palletId, stationId: stationId, loadTime: loadTime, loadTimeISO: loadTime.toISOString(), loadOperatorId: values.loadOperatorId,
        stationInfo: stationInfo.data, loadOperatorInfo: checkInInfo.data};

    await createNew(data);

}

export const onFinishPallet = async (values)=> {

    var checkInInfo = await new CheckInStore().read();

    // If different person is loading than is checked in
    // Go ahead and check them in
    const checkedInId = checkInInfo ? checkInInfo.data.personId : null;
    if (values.unloadOperatorId != checkedInId) {
        await new CheckInStore().save(values.unloadOperatorId);
        checkInInfo = await new CheckInStore().read();
    }

    // Pull the jobs
    const response = await getCurrentPressPallet();
    const pallet = response.data;
    pallet.unloadOperatorId = values.unloadOperatorId;
    pallet.unloadOperatorInfo = checkInInfo.data;
    pallet.unloadTime = new Date();
    pallet.unloadTimeISO = pallet.unloadTime.toISOString();
    const cloned = _.clone(pallet);
    await save(pallet);
    pallet.unloadOperatorInfo = checkInInfo;
    return cloned;
    console.log('Finishing a pallet', {values});


}

export const printManifest = async (pallet, saveDesignerData=false, stationId) => {

    console.log("Printing manifest", {pallet});
    const station = await new StationsStore().findById(stationId);
    const site = station.data.siteId;
    const stationName = station.data.name;

    const pdfName = site + "__" + stationName + "__" + pallet.id + ".pdf";

    // Print the manifest
    const report = 'palletManifest';
    const manifestJson = {
        "reportBucket": firebaseConfig.storageBucket,
        "reportPath": "reporttemplates/" + report + ".zip/reportZip",
        "reportNameInZip": report + ".jasper",
        data: pallet
    };
    console.log('Calling print with params', manifestJson);
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(manifestJson)
    };
    var blob = new Blob([JSON.stringify(manifestJson.data)], {type: "text/plain;charset=utf-8"});

    saveDesignerData && saveAs(blob, "designerData.json");

    //console.log('Data source is: ', JSON.stringify(manifestJson.data));



    const response = await fetch('/api/jasperReportGeneratorJson', requestOptions);
    if (!response.ok) {
        console.log(response);
        throw new Error('Failed to fetch: ' + response.statusText);
    }
    const responseBlob = await response.blob();


    // Connect to storage
    var storage = firebase.storage();
    var storageRef = storage.ref();
    var IPTCloudPrintBucket = storageRef.child('IPTCloudPrintOnPrem');
    var manifestRef = IPTCloudPrintBucket.child(pdfName);

    await manifestRef.put(responseBlob);
    // saveAs(blob, 'palletManifest.pdf'));

}


export const getPalletEvents = async ()=> {

    return [];

}


export const getCurrentPressPallet = async () => {
    const result = await getCurrentPressPallets(1);
    if (!result.data)
        return null;
    const pallet = result.data[0];

    // Detect if pallet is done
    if (!pallet || pallet.unloadTime)
        return null;

    const jobs = await getJobsForPallet(pallet, 500);
    pallet.jobs = jobs.data;
    pallet.jobCount = jobs.data.length;
    pallet.spreadCount = 0;
    pallet.jobs.forEach((job)=> {
       pallet.spreadCount += job.spreads ? job.spreads : 0;
    });

    return {data: pallet};

}

export const getJobsForPallet = async (pallet, limit) => {

    const jobs = await getJobsBetween(pallet.stationInfo, pallet.loadTime, pallet.unloadTime,limit);
    return jobs;

}

export const operatorExists = async (id) => {
    return new Promise((resolve, reject) => {
        new PeopleStore().findById(id).then((data) => {
            // exists
            resolve(true)
        }).catch(() => {
            // note exists
            resolve(false)
        })
    })
}
